module.exports = __webpack_public_path__ + "img/logo.fca33228.svg";